import * as React from "react";
import { format, isValid, parseISO } from "date-fns";
import { enGB } from "date-fns/locale";
import { styled } from "styled-components";

export enum DateTimeFormats {
  DATE = "dd-MM-yyyy",
  TIME = "HH:mm",
}

const Time = styled.time`
  white-space: nowrap;
`;

export const DateTimeFormat = (value: string, _format: DateTimeFormats): string => {
  const dateIsValid = isValid(parseISO(value));
  return dateIsValid ? format(new Date(value), _format, { locale: enGB }) : "";
};

export const DateTime: React.FC<{ value: string; format: DateTimeFormats }> & { FORMAT: typeof DateTimeFormats } = ({
  value,
  format: _format,
}) => {
  const dateIsValid = isValid(parseISO(value));
  return dateIsValid ? <Time dateTime={value}>{DateTimeFormat(value, _format)}</Time> : null;
};

DateTime.FORMAT = DateTimeFormats;
